export class HttpError extends Error { } // todo: move this out of adyen to common
